import { useLocation } from 'react-router-dom';

export const queryString = () => useLocation().search;
export const useQuery = () => new URLSearchParams(queryString());
